/**
 * Submit Buttons Component
 * Calculate valuation and advanced multi-year analysis buttons
 */
import React from 'react';
import PropTypes from 'prop-types';
import { TrendingUp, BarChart3 } from 'lucide-react';

const SubmitButtons = ({
  loading,
  result,
  onShowAdvancedModal,
  isViewer = false
}) => {
  // Don't render buttons for viewers
  if (isViewer) {
    return null;
  }

  return (
    <>
      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6 rounded-lg text-lg font-bold hover:from-blue-700 hover:to-indigo-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
            Calculating...
          </>
        ) : (
          <>
            <TrendingUp size={20} />
            {result ? 'Recalculate Median Value' : 'Calculate Median Value'}
          </>
        )}
      </button>

      {/* Advanced Valuation Button */}
      <button
        type="button"
        onClick={onShowAdvancedModal}
        className="w-full mt-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-purple-700 hover:to-indigo-700 transition-colors flex items-center justify-center gap-2"
      >
        <BarChart3 size={20} />
        Advanced Multi-Year Analysis
      </button>

      {result && (
        <p className="text-xs text-gray-500 text-center mt-2">
          💡 Tip: Adjust the discount slider above to see real-time valuation changes
        </p>
      )}
    </>
  );
};

SubmitButtons.propTypes = {
  loading: PropTypes.bool.isRequired,
  result: PropTypes.object,
  onShowAdvancedModal: PropTypes.func.isRequired,
  isViewer: PropTypes.bool
};

export default SubmitButtons;
